<template>
    <div>

        <vue-headful title="Training Course Catalogs :: MeritEHS"/>

        <h4 class="py-2 mb-3">
            <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Catalogs</li>

                <li class="ml-3 d-sm-inline-block d-none" v-if="this.$root.hasPermission(['training_courses.manage'])">
                    <router-link :to="`/training-courses/catalogs/create`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
                </li>
            </ol>
        </h4>

        <div class="d-sm-none d-block mb-3" v-if="this.$root.hasPermission(['training_courses.manage'])">
            <router-link :to="`/training-courses/catalogs/create`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
        </div>

        <div class="card mt-1">
            <div class="card-body">
                <v-client-table ref="emailRulesTable" :columns="columns" :options="options" :data="catalogs">
                    <template slot="id" slot-scope="props">
                        <router-link  :to="`/training-courses/catalogs/edit/${props.row.id}`" title="Edit Catalog" class="btn btn-sm btn-light">
                            <i class="fa fa-edit"></i> Edit
                        </router-link>
                        <router-link :to="`/training-courses/catalogs/delete/${props.row.id}`" title="Delete Catalog" class="btn btn-sm btn-light">
                            <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                        </router-link>
                    </template>

                    <router-link slot="catalog_name" slot-scope="props" :to="`/training-courses/catalogs/view/${props.row.id}`" title="View Catalog">
                        {{ props.row.catalog_name }}
                    </router-link>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                catalogs: [],
                columns: ['id', 'catalog_name', 'catalog_description'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        catalog_name: 'Name',
                        catalog_description: 'Description',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'training_catalogs.id',
                    },
                }
            }
        },

        methods: {
            //Load the Account
            getAlerts(){
                //Send it
                this.$http.get('training-courses/catalogs')
                    .then(res => {
                        //Set data
                        this.catalogs = res.data.catalogs;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            this.getAlerts();
        },
    }
</script>
